import React, { useEffect, useState } from "react";

const HelpUs = () => {
  const [help, setHelp] = useState({});
  const url = process.env.REACT_APP_API_URL;

  const fetchHelpuser = async () => {
    try {
      const response = await fetch(`${url}/help/single/${process.env.REACT_APP_PERFUME_ID}`);
      const res = await response.json();
      setHelp(res.help || {});
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchHelpuser();
  }, []);

  return (
    <div className="helpus-options">
      {/* Chat with us - WhatsApp */}
      {help.whatsapp_number && (
        <div className="helpus-box">
          <h3>Chat with us</h3>
          <p>Instantly connect with us for quick support and queries.</p>
          <a
            href={`https://wa.me/91${help.whatsapp_number}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="helpus-button">Start Chat</button>
          </a>
        </div>
      )}

      {/* Talk to us - Phone Call */}
      {help.mobile && (
        <div className="helpus-box">
          <h3>Talk to us</h3>
          <p>Speak with our team directly for personalized assistance.</p>
          <a href={`tel:+91${help.mobile}`}>
            <button className="helpus-button">Start Call</button>
          </a>
        </div>
      )}
    </div>
  );
};

export default HelpUs;
